import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "./api";
import { useAuth } from "./AuthContext";
import { LOGO_URL, BRAND } from "./brand";

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh, setUser } = useAuth();
  const hasRun = React.useRef(false);
  const [err, setErr] = React.useState("");

  React.useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) { nav("/login"); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sid });
        if (data?.token) localStorage.setItem("arya_token", data.token);
        if (data?.user && setUser) setUser(data.user);
        window.history.replaceState(null, "", "/perfil");
        try { await refresh(); } catch {}
        toast.success("Bem-vinda de volta!");
        nav("/perfil", { replace: true });
      } catch (e) {
        const detail = e?.response?.data?.detail || e?.message || "Erro ao entrar com Google";
        setErr(typeof detail === "string" ? detail : "Erro ao entrar com Google");
        toast.error("Não foi possível concluir o login com Google. Verifique o console para detalhes.");
        setTimeout(() => nav("/login", { replace: true }), 3500);
      }
    })();
  }, [nav, refresh, setUser]);

  return (
    <div className="min-h-screen grid place-items-center px-6">
      <div className="flex flex-col items-center gap-3 text-center max-w-md">
        <img src={LOGO_URL} alt={BRAND.name} className="w-28 h-28 object-contain animate-pulse" />
        <p className="font-display text-sm text-[color:var(--ink-500)]">Autenticando com Google...</p>
        {err && (
          <div className="mt-2 rounded-xl border border-[color:var(--danger)]/40 bg-[rgba(179,58,58,.06)] text-[color:var(--danger)] p-3 text-xs" data-testid="google-error">
            {err}
          </div>
        )}
      </div>
    </div>
  );
}
